import script from "./category-title.vue?vue&type=script&setup=true&lang=js"
export * from "./category-title.vue?vue&type=script&setup=true&lang=js"

import "./category-title.vue?vue&type=style&index=0&id=20fc523f&lang=scss&scoped=true"

import exportComponent from "/data/project/activity-v3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20fc523f"]])

export default __exports__